import React, { Component } from "react";
import { connect } from "react-redux";
import InputComponent from "../../components/form/InputComponent";
import { css } from "aphrodite";
import SearchIcon from "@material-ui/icons/Search";
import _ from "lodash";
import Button from "@material-ui/core/Button";
import { FilterList } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import { history } from "../../helpers/history";
import { listHeaderStyles as styles } from "../../components/header/listHeaderStyles";

class HeaderJobSpot extends Component {
  constructor(props) {
    super(props);
    this.handleChangeNama = this.handleChangeNama.bind(this);
  }

  delayedQuery = _.debounce((value) => {
    this.props.handleRefresh(value);
  }, 500);

  handleChangeNama(e) {
    if (e !== null) {
      this.setState({ nama: e.target.value });
      this.delayedQuery({ search: e.target.value });
    } else {
      this.setState({ nama: "" });
      this.delayedQuery({ search: "" });
    }
  }

  addMessage = () => {
    history.push("/jobspot/add");
  };

  render() {
    return (
      <div className={css(styles.bar)}>
        <div className={css(styles.title)}>
          <Button
            variant="contained"
            color="primary"
            className={css(styles.buttonFull)}
            startIcon={<AddIcon />}
            onClick={this.addMessage}
          >
            Tambah Lowongan
          </Button>
        </div>
        <div className={css(styles.actions)}>
          <div className={css(styles.field)}>
            <InputComponent
              onChange={this.handleChangeNama}
              placeholder="Nama Pekerjaan/Instansi"
              endIcon={SearchIcon}
              id="nama"
            />
          </div>
          <div className={css(styles.fieldNarrow)}>
            <Button
              className={css(styles.filterButton)}
              onClick={this.props.onShowModal}
            >
              <span>Filter</span>
              <FilterList
                fontSize="medium"
                style={{ paddingLeft: 3 }}
              />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(HeaderJobSpot);
